import { render, staticRenderFns } from "./SingleThumbnail.vue?vue&type=template&id=afc07d32&scoped=true"
import script from "./SingleThumbnail.vue?vue&type=script&lang=js"
export * from "./SingleThumbnail.vue?vue&type=script&lang=js"
import style0 from "./SingleThumbnail.vue?vue&type=style&index=0&id=afc07d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc07d32",
  null
  
)

export default component.exports